var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-h4 ml-1"},[_vm._v("My Searches")]),_c('v-card',{staticClass:"my-4",attrs:{"rounded":"","outlined":""}},[_c('v-alert',{attrs:{"type":"warning","icon":"mdi-progress-wrench"}},[_vm._v(" Support for saved searches will be coming soon. ")]),_c('v-card-text',[_vm._v("You don't have any saved searches yet.")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }